/**
 * Build params to append to URL for requests.
 * @param payload Params to build
 * @returns params to append to URL
 */
function buildParams(payload: Record<string, string | number>): string {
  const params = [];

  for (const key in payload) {
    params.push(`${key}=${payload[key]}`);
  }

  return params.length ? `?${params.join("&")}` : "";
}

const Fetch = {
  async post(url: string, token = "" as string, data = {} as {}) {
    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/${url}`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(token && { "x-csrf-token": token })
      },
      body: JSON.stringify(data)
    });
    const json = await this.checkResponse(response);
    return json;
  },

  async put(url: string, token = "" as string, data = {} as {}) {
    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/${url}`, {
      method: "PUT",
      mode: "cors",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(token && { "x-csrf-token": token })
      },
      body: JSON.stringify(data)
    });
    const json = await this.checkResponse(response);
    return json;
  },

  async get(
    url: string,
    token = "" as string,
    params = {} as Record<string, string | number>
  ) {
    const response = await fetch(
      `${process.env.VUE_APP_API_URL}/api/${url}${buildParams(params)}`,
      {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(token && { "x-csrf-token": token })
        }
      }
    );
    const json = await this.checkResponse(response);
    return json;
  },

  async checkResponse(response: Response) {
    if (!response.ok) {
      const body = await response.json();
      throw body.error;
    }
    return response.json();
  }
};

export { Fetch };
